import type { SVGProps } from "react";
export interface ChartLineHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChartLineHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChartLineHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 11V6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h5l.115.006a1.125 1.125 0 0 1 0 2.238l-.116.006H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6v5a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M19.957 13.876c.936 0 1.746.479 2.29 1.101.546.627.902 1.484.873 2.408l.003.002c-.037 1.226-.76 2.165-1.421 2.852l-.277.28c-.49.48-.961.923-1.367 1.3l-.98.897a1.614 1.614 0 0 1-2.039.096l-.119-.096c-.35-.314-.944-.854-1.633-1.509l-.715-.688c-.718-.703-1.656-1.731-1.697-3.132l.001-.002a3.52 3.52 0 0 1 .875-2.408c.543-.622 1.353-1.101 2.289-1.101.866 0 1.5.306 1.959.687.457-.381 1.092-.687 1.958-.688Zm0 2.25c-.294 0-.46.102-.587.228a1.4 1.4 0 0 0-.201.26l-.157.295-.001.002c-.008.016-.02.032-.028.048L18.96 17a1.1 1.1 0 0 1-.182.223 1 1 0 0 1-.206.164l-.02.01q-.032.02-.065.037a1.1 1.1 0 0 1-.268.085 1.12 1.12 0 0 1-.71-.085q-.034-.018-.067-.037l-.019-.01a1 1 0 0 1-.146-.106q-.032-.027-.062-.058a1 1 0 0 1-.181-.223l-.022-.041-.027-.048-.001-.002c-.098-.202-.2-.4-.358-.555-.127-.126-.293-.228-.587-.229-.148 0-.379.084-.595.331a1.3 1.3 0 0 0-.319.746l-.002.114v.003l.018.16c.073.38.372.814 1.003 1.431l.693.668c.44.418.842.785 1.16 1.075a74 74 0 0 0 1.854-1.743l.25-.255c.538-.566.76-.968.77-1.336v-.117a1.3 1.3 0 0 0-.32-.746c-.216-.247-.447-.33-.595-.33Zm-4.252-7.421a1.125 1.125 0 1 1 1.59 1.59l-2.698 2.699c-.69.689-1.76.82-2.595.319l-1.079-.646-2.628 2.628a1.125 1.125 0 1 1-1.59-1.59l2.698-2.698.133-.123a2.13 2.13 0 0 1 2.303-.284l.16.088 1.076.644z"
      />
    </svg>
  );
}
